import React, { PropTypes } from 'react';
import { NitroMultipleSelect } from 'nitro-components';

import Filter from '../Filter';

const MultipleSelect = ({ filter, action }) => {
  // add custom onChange handler to send back label
  const onChange = option => {
    action({
      value: option.value,
      label: option.value
    });
  };

  return (
    <NitroMultipleSelect
      value={filter.value}
      options={filter.options}
      action={onChange}
      mandatory={filter.mandatory}
    />
  );
};

MultipleSelect.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired
};

MultipleSelect.getLabel = Filter.getLabel;

export default MultipleSelect;



// WEBPACK FOOTER //
// ./src/components/filter/filters/multiple-select/MultipleSelect.js